import React from 'react';
import { Button } from 'components/button';
import { Icon } from 'components/icon/icon';
import { capitalizeFirstLetter } from 'utils/capitalize';
import { truncate } from 'lodash';
import IconChevronRight from 'public/assets/icons/chevron-right.svg';
import styles from './search-overview.module.scss';

export const getBreadCrumb = (slug: string | null | undefined, idx: number): React.JSX.Element => {
	const splitSlug = slug?.split('/').filter(Boolean) || [];

	return (
		<div className={styles.breadCrumb}>
			<Button variant="tertiary-dark" title="Home" href="/" />

			{splitSlug.map((splitted, index) => {
				let href = '';
				if (index) {
					for (let i = 0; i <= index; i += 1) {
						href = `${href}/${splitSlug[i]}/`;
					}
				} else {
					href = `/${splitted}/`;
				}
				href = href.replaceAll('//', '/');

				if (!href.startsWith('/')) {
					href = `/${href}`;
				}

				const breadcrumbText = capitalizeFirstLetter(truncate(splitted.replaceAll('-', ' '), { length: 30 }));

				return (
					<div key={`card-${idx}-${index}`} className={styles.BreadcrumbCard}>
						<span className={styles.breadCrumbIcon}>
							<Icon customIcon={<IconChevronRight />} size="10px" />
						</span>
						<Button variant="tertiary-dark" title={breadcrumbText} href={href} />
					</div>
				);
			})}
		</div>
	);
};
